import React, { useState, useEffect, useContext } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
  Container,
  Typography,
} from '@material-ui/core';

import LanguageContext from "../contexts/LanguageContext"

const ErrorLogin = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)


  return (
    <>
      <Helmet>
        <title>{languageValues?.loginPage?.title[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Box sx={{ mb: 2, textAlign:"center" }}>
            <Typography
              color="text.blackTitle"
              variant="h2"
            >
              {languageValues?.errorLogin?.title[actLanguage]}
            </Typography>
          </Box>
          <Box
            sx={{
              fontSize:"18px",
              color:"text.black",
              textAlign:"center",
              marginBottom:"15px",
              whiteSpace:"pre-wrap",
            }}
          >
            {languageValues?.errorLogin?.texte[actLanguage]}
          </Box>
          <Box sx={{ py: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => { navigate("/login") }}
            >
              {languageValues?.errorLogin?.button[actLanguage]}
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ErrorLogin;
